import React, { useMemo } from 'react';
import { Form, Row, Col } from 'antd';
import { createFormRows } from '../../lib';
import { ShutdownField } from '../../../common/ui/ShutdownField';
import {
  useNewCityValueEmitFormMount,
  useNewCompanyValueEmitFormMount,
} from '../../../common/lib/subscriptions';
import styles from './CreateShutdownForm.module.scss';

const CreateShutdownForm = ({
  form,
  initialValues = {},
  renderResTemplateAction,
  renderResTemplateOptionActions,
}) => {
  useNewCompanyValueEmitFormMount({ form });
  useNewCityValueEmitFormMount({ form });

  const rows = useMemo(
    () => createFormRows({ initialValues }),
    [JSON.stringify(initialValues)]
  );

  return (
    <Form
      colon={false}
      className={styles.root}
    >
      {rows.map((row, rowIndex) => (
        <Row
          key={rowIndex}
          {...(row.props || {})}
        >
          {row.cols.map((col, colIndex) => (
            <Col
              key={colIndex}
              {...(col.props || {})}
            >
              {col.fields.map((field) => {
                return (
                  <ShutdownField
                    key={field.name}
                    form={form}
                    renderResTemplateAction={renderResTemplateAction}
                    renderResTemplateOptionActions={
                      renderResTemplateOptionActions
                    }
                    {...field}
                  />
                );
              })}
            </Col>
          ))}
        </Row>
      ))}
    </Form>
  );
};

export default CreateShutdownForm;
